import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  props: {
    ranking: {
        type: Object,
        required: true
    }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, _toDisplayString(props.ranking.hiding_ranking_message.title), 1),
    _createElementVNode("h3", null, _toDisplayString(props.ranking.hiding_ranking_message.subtitle), 1),
    _createElementVNode("p", null, _toDisplayString(props.ranking.hiding_ranking_message.text), 1)
  ]))
}
}

})